var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37418 8.2291C1.31863 8.07947 1.31863 7.91489 1.37418 7.76526C1.91512 6.45363 2.83333 5.33215 4.01242 4.54301C5.1915 3.75386 6.57836 3.33258 7.99716 3.33258C9.41596 3.33258 10.8028 3.75386 11.9819 4.54301C13.161 5.33215 14.0792 6.45363 14.6201 7.76526C14.6757 7.91489 14.6757 8.07947 14.6201 8.2291C14.0792 9.54073 13.161 10.6622 11.9819 11.4514C10.8028 12.2405 9.41596 12.6618 7.99716 12.6618C6.57836 12.6618 5.1915 12.2405 4.01242 11.4514C2.83333 10.6622 1.91512 9.54073 1.37418 8.2291Z",
    stroke: "#155DFC",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99709 9.99644C9.10127 9.99644 9.99638 9.10133 9.99638 7.99715C9.99638 6.89298 9.10127 5.99786 7.99709 5.99786C6.89292 5.99786 5.9978 6.89298 5.9978 7.99715C5.9978 9.10133 6.89292 9.99644 7.99709 9.99644Z",
    stroke: "#155DFC",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAye);
export default __webpack_public_path__ + "static/media/Aye.0ddd24be25eec42dd5f86d9654bc2bef.svg";
export { ForwardRef as ReactComponent };